import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';
import { createMockApiResponse, isMockModeEnabled, loadMockClaims } from '../utils/mockDataHelper';

// Statuses that carry a usable claims body. The API only ever sends 200.
const SUCCESS_STATUSES = [200];

export async function getClaims(urlKey: string, sessionId: string, custKey: string) {
  // If in mock mode, return mock claims data
  if (isMockModeEnabled()) {
    console.log('🔧 Mock Mode: Using mock claims data');

    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    const mockData = await loadMockClaims();

    // Deep clone the mock data to prevent mutation errors in Redux
    const clonedMockData = JSON.parse(JSON.stringify(mockData));

    return createMockApiResponse(clonedMockData.claims);
  }

  // Otherwise, use real API
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}claim/v3/claims`;
    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });
    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;

    const httpStatus = Number(_get(response, 'status', 0));

    // Check the HTTP status, not the body. The 500 nests its code in status and reads as success.
    if (SUCCESS_STATUSES.includes(httpStatus)) {
      // Has data, plus partialFailures when there is something to report.
      return responseData;
    } else {
      // Keep status for status.failureReason. message is for logs only, not for the customer.
      return {
        error: error ?? true,
        statusCode: _get(responseData, 'status.statusCode', statusCode ?? httpStatus),
        status: _get(responseData, 'status'),
        message,
      };
    }
  } catch (error) {
    console.log('getClaims:error', error);
    return error;
  }
}
